export const mutations = {
  // Counts belong to one scope (user + dealer filter). Entering a new scope drops the old
  // counts so they are never shown, or merged with a failed request's fallback, under another.
  setNewCountsScope(state, scope) {
    if (state.scope === scope) return;
    state.scope = scope;
    state.buyingNewCount = 0;
    state.sellingNewCount = 0;
  },
  // `undefined` keeps the current value (a failed request) within the same scope
  setNewCounts(state, { buying, selling }) {
    state.buyingNewCount = buying ?? state.buyingNewCount;
    state.sellingNewCount = selling ?? state.sellingNewCount;
  },
};

export const getters = {
  buyingNewCount: (state) => state.buyingNewCount,
  sellingNewCount: (state) => state.sellingNewCount,
  newCount: (state) => state.buyingNewCount + state.sellingNewCount,
};

export const state = {
  scope: null,
  buyingNewCount: 0,
  sellingNewCount: 0,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
